import React, { useEffect, useState } from 'react';
import { useAlert } from 'react-alert';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import {
  getTotem,
  setAuthToken,
} from '../../api/apiFactory';
import {
  fetchBairros,
  fetchOrientacoes, fetchVerificarStatusCidade, fetchConfiguracoes, fetchUrgenteJustificativas, fetchCategoriasPermitidas, fetchSecretarias3, postZeladoria,
} from '../../api/endpoints';
import {
  selectModal,
} from '../../app/slices/modalSlice';
import { fetchGeocodeByCoords, fetchCoordsByAddress } from '../../api/googleMaps';
import { desfazerCidade, selectCidade } from '../../app/slices/cidadesSlice';
import { desfazerConexao, selectLogin } from '../../app/slices/loginSlice';
import { desfazerSecretaria, selectSecretaria } from '../../app/slices/secretariasSlice';
import {
  Alerta,
  Container, Divisor, FormFooter, Interno, Titulo, Linha,
} from '../../styles/base';
import {
  cep, number, sus,
} from '../../util/mascaras';
import Botao from '../Botao/Botao';
import Carregar from '../Carregar/Carregar';
import FormControl from '../FormControl/FormControl';
import {
  ColunaForm, LinhaForm, LinhaFormGap, Pergunta,
} from '../FormControl/FormControlEstilo';
import Mapa from '../Mapa/Mapa';
import { Orientacoes, OrientacoesLocalizacao } from './FormularioZeladoriaEstilo';
import { selectBairroTotem, desfazerBairro } from '../../app/slices/bairroTotemSlice';
import { desfazerAssunto, selectAssuntoTotem } from '../../app/slices/assuntoTotemSlice';
import { desfazerCategoria, selectCategoriaTotem } from '../../app/slices/categoriaTotemSlice';
import { desfazerUnidade, selectUnidadeTotem } from '../../app/slices/unidadeTotemSlice';

const defaultValues = {
  CartaoSus: '',
  Cep: '',
  DadosSigilosos: 'N',
  Descricao: '',
  Endereco: '',
  Foto: '',
  FuncionarioPublico: 'N',
  IdBairro: '',
  IdCategoria: '',
  IdSecretariaAssunto: '',
  IdUnidade: null,
  IdOpcaoUrgencia: '',
  Latitude: '',
  Longitude: '',
  Numero: '',
  Referencia: '',
  Urgente: 'N',
};

const FormularioZeladoria = () => {
  const [listaSecretarias, setListaSecretarias] = useState(null);
  const [listaCategorias, setListaCategorias] = useState(null);
  const [listaAssuntos, setListaAssuntos] = useState(null);
  const [listaUnidades, setListaUnidades] = useState(null);
  const [listaBairros, setListaBairros] = useState(null);
  const [listaUrgenteJustificativas, setListaUrgenteJustificativas] = useState(null);
  const [orientacoes, setOrientacoes] = useState(null);
  const [values, setValues] = useState(defaultValues);
  const [carregando, setCarregando] = useState(false);
  const [arquivos, setArquivos] = useState([]);

  const [selectDesabilitadoCategoria, setSelectDesabilitadoCategoria] = useState(true);

  const alert = useAlert();
  const history = useHistory();
  const dispatch = useDispatch();
  const dadosCidade = useSelector(selectCidade);
  const dadosSecretaria = useSelector(selectSecretaria);
  const dadosLogin = useSelector(selectLogin);
  const { bairroTotem } = useSelector(selectBairroTotem);
  const { assuntoTotem } = useSelector(selectAssuntoTotem);
  const { categoriaTotem } = useSelector(selectCategoriaTotem);
  const { unidadeTotem } = useSelector(selectUnidadeTotem);

  // Campos abaixo usados para controlar se o usuário não deu permissão para consultar localização, ou para conferir se a localização bata com a da cidade
  const [EstaNaMesmaCidade, setEstaNaMesmaCidade] = useState(true);
  const [logErroLocalizacao, setLogErroLocalizacao] = useState('');

  useEffect(() => {
    setValues({ ...values, IdBairro: bairroTotem && bairroTotem.bairroId });
  }, [bairroTotem]);

  useEffect(() => {
    setValues({ ...values, IdAssunto: assuntoTotem && assuntoTotem.assunto, IdSecretariaAssunto: assuntoTotem && assuntoTotem.assuntoId });
  }, [assuntoTotem]);

  useEffect(() => {
    setValues({ ...values, IdCategoria: categoriaTotem && categoriaTotem.categoriaId });
  }, [categoriaTotem]);

  useEffect(() => {
    setValues({ ...values, IdUnidade: unidadeTotem && unidadeTotem.unidadeId });
  }, [unidadeTotem]);

  const limpaLoginAnonimo = (data) => {
    if (data && data.data && data.data.anonimo === 'anonimo') {
      setAuthToken(null);
      dispatch(desfazerConexao());
    }
  };

  const checaCidadeAtiva = (id) => {
    if (id) {
      fetchVerificarStatusCidade(id).then((response) => {
        if (response === 'N') {
          dispatch(desfazerConexao());
          dispatch(desfazerCidade());
          dispatch(desfazerSecretaria());
          limpaLoginAnonimo(dadosLogin);
          history.push('/');
        }
      });
    } else {
      history.push('/');
    }
  };

  const validate = () => {
    if (!values.IdSecretariaAssunto) {
      alert.error('Verifique o campo assunto.', { timeout: 5000 });
      return false;
    }
    if (!values.IdCategoria) {
      alert.error('Verifique o campo categoria.', { timeout: 5000 });
      return false;
    }
    if (!values.Descricao) {
      alert.error('Verifique o campo manifestação.', { timeout: 5000 });
      return false;
    }
    if (!values.Endereco) {
      alert.error('Verifique o campo endereço da manifestação.', { timeout: 5000 });
      return false;
    }
    if (!values.IdBairro && values.Bairro !== '') {
      alert.error('Verifique o campo bairro.', { timeout: 5000 });
      return false;
    }
    if (!values.IdBairro) {
      alert.error('Verifique o campo bairro.', { timeout: 5000 });
      return false;
    }
    if (values.Urgente === 'S' && !values.IdOpcaoUrgencia) {
      alert.error('Verifique todos os campos obrigatórios.', { timeout: 5000 });
      return false;
    }
    if (values.Urgente === 'S' && (!arquivos || arquivos.length === 0)) {
      alert.error('Ao solicitar prioridade na tramitação, deverá, obrigatoriamente, anexar prova de sua condição.', { timeout: 5000 });
      return false;
    }
    return true;
  };

  const [coordenadas, setCoordenadas] = useState({
    lat: Number(dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.Latitude),
    lng: Number(dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.Longitude),
  });

  const identificarCidade = async (lat, lng) => {
    const responseCidade = await fetch(`https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`);

    const data = await responseCidade.json();

    if (data && data.address) {
      return data.address.city;
    }

    return '';
  };

  const compararLocalizacao = async () => {
    try {
      // Foi preciso colocar o getCurrentPosition dentro de uma Promise para tornar possível a utilização do await aqui, e fazer com que a execução do método continue apenas após a conclusão do método.
      // Dito isso, agora eu consigo utilizar o await E também armazenar o retorno do "getCurrentPosition" em uma constante.
      // Se você reparar como era feito antes (no bloco comentado dentro do UseEffect abaixo), verá que não fica armazenado nada dentro de um objeto. Dentro da própria chamada do método, eu já utilizava o retorno (position) para capturar a localização do usuário.
      const posicaoUsuario = await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject);
      });

      // CÓDIGO QUE SETA A LOCALIZAÇÃO ATUAL DO USUÁRIO COMO LOCALIZAÇÃO INICIAL PADRÃO DO MAPA. UMA VEZ COMENTADO, A LOCALIZAÇÃO PADRÃO SERÁ A CADASTRADA NO EOUVE.
      // setCoordenadas({
      //   lat: posicaoUsuario.coords.latitude,
      //   lng: posicaoUsuario.coords.longitude,
      // });

      const cidadeAtualUsuario = await identificarCidade(posicaoUsuario.coords.latitude, posicaoUsuario.coords.longitude);
      const cidadeSelecionada = await identificarCidade(coordenadas.lat, coordenadas.lng);

      if (cidadeAtualUsuario !== cidadeSelecionada) {
        setEstaNaMesmaCidade(false);
        setLogErroLocalizacao('Sua atual localização não coincide com o endereço da cidade selecionada.');
      }
    } catch {
      setEstaNaMesmaCidade(false);
      setLogErroLocalizacao('Não conseguimos identificar sua atual localização. Por favor, verifique se a permissão de acesso à localização está habilitada.');
    }
  };

  const setVal = (key, val) => setValues({
    ...values, [key]: val,
  });

  useEffect(() => {
    // O CÓDIGO ABAIXO É RESPONSÁVEL POR SETAR NO MAPA COMO LOCALIZAÇÃO PADRÃO, A POSIÇÃO COM AS COORDENADAS DO USUÁRIO.
    // Uma vez comentado, o mapa irá renderizar por padrão as coordenadas vindas do banco, definidas na criação do useState "coordenadas";
    // Aqui, você vê que eu chamo o "getCurrentPosition", e já utilizo o retorno desse método (que é o objeto "position") para popular as coordenadas.

    // navigator.geolocation.getCurrentPosition((position) => {
    //   setCoordenadas({
    //     lat: position.coords.latitude,
    //     lng: position.coords.longitude,
    //   });
    // });

    compararLocalizacao();

    dispatch(desfazerBairro());
    dispatch(desfazerAssunto());
    dispatch(desfazerCategoria());
    dispatch(desfazerUnidade());
  }, []);

  useEffect(() => {
    checaCidadeAtiva(dadosCidade && dadosCidade.data && dadosCidade.data.idCidade);
    Promise.all([
      fetchSecretarias3(),
      // fetchCategorias(), Removi a chamada do método que carrega as categorias pois agora teremos um método novo que trará as categorias se baseando nos assuntos da secretaria selecionada. OBS: tive que remover também do then() abaixo, a propriedade "dadosCategorias"
      fetchBairros(),
      fetchUrgenteJustificativas(),
    ]).then(([dadosSecretarias, dadosBairros, dadosUrgenteJustificativas]) => {
      setListaSecretarias(dadosSecretarias);
      setListaBairros(dadosBairros);
      setListaUrgenteJustificativas(dadosUrgenteJustificativas);
      setValues(defaultValues);

      // Verifica se há apenas um bairro. Caso sim, atribui automaticamente o ID do único bairro. Provavelmente será o bairro "Outros"
      if (dadosBairros && dadosBairros.length === 1) {
        setVal('IdBairro', dadosBairros[0].Id);
      }

      const secretaria = dadosSecretarias && dadosSecretarias.find(
        ({ Id }) => Id === dadosSecretaria.data.idSecretaria,
      );

      if (!secretaria) {
        history.push('/');
        dispatch(desfazerConexao());
        dispatch(desfazerSecretaria());
      }

      const assuntos = secretaria && secretaria.Assuntos;
      const unidades = secretaria && secretaria.Unidades;

      setListaAssuntos(assuntos);
      setListaUnidades(unidades);
    });
  }, [dadosSecretaria, dadosLogin]);

  if (!listaSecretarias || !listaAssuntos || /* !listaCategorias || */ !listaBairros || !listaUrgenteJustificativas) {
    return (
      <Carregar />
    );
  }

  if (/* listaCategorias.Error || */ listaAssuntos.Error || listaBairros.Error || listaUrgenteJustificativas.Error) {
    history.push('/');
    dispatch(desfazerConexao());
    dispatch(desfazerCidade());
    dispatch(desfazerSecretaria());
    return (
      <Carregar />
    );
  }

  const getIdBairro = (nomeBairro) => {
    if (!listaBairros) {
      return 'null';
    }

    const bairro = listaBairros.find(({ Campo }) => Campo === nomeBairro);
    if (!bairro) {
      return '';
    }
    return bairro.Id;
  };

  const removerArquivo = ({ path }) => {
    setArquivos(arquivos.filter((arq) => arq.path !== path));
  };

  const adicionarArquivo = async (arquivo) => {
    // Você deve estar se perguntando por que eu não valido aqui dentro se o arquivo tem tamanho superior à 200MB, já que todas as lógicas estão aqui. Ao invés disso eu criei um atributo de "onDropRejected" só pra exclusivamente validar esse erro.
    // Isso se deve pois o componente formControl do tipo arquivo recebe um atributo chamado maxSize que nativamente valida o tamanho do arquivo, e caso o tamanho seja superior a 200MB (eu que defini), o componente bloqueia a adição do arquivo e nem sequer entra nesse método, que é acionado no "onDrop".
    // Dito isso, eu não consigo personalizar uma mensagem de erro para esse cenário, e portanto adicionei um evento que é acionado justamente quando o arquivo não é adicionado nativamente devido à alguma restrição de atributo (no caso do maxSize);

    // Conferindo limite de 10 arquivos
    if (arquivos && (arquivo.length + arquivos.length > 10)) {
      return (
        alert.error('Limite de 10 arquivos permitido.', { timeout: 5000 })
      );
    }

    // Conferindo se há arquivo repetido
    const validarRepetidos = () => {
      const arquivoExiste = arquivo.map(({ path: arq }) => arquivos && arquivos.length && arquivos.find(({ path }) => arq === path))[0];
      const caminhoRepetido = arquivoExiste && arquivo.map(({ path: arq }) => arquivos && arquivos.length && arquivos.find(({ path }) => arq === path))[0].path;

      return caminhoRepetido;
    };

    if (validarRepetidos()) {
      return (
        alert.error('Você já subiu um arquivo com esse nome.', { timeout: 5000 })
      );
    }

    return (
      setArquivos(arquivos.concat(arquivo.map((file) => Object.assign(file, {
        preview: URL.createObjectURL(file),
      }))))
    );
  };

  const ExibirErroTamanhoArquivo = (arquivo) => {
    // Você deve estar se perguntando: "Por que não fez essa validação também no método de adição de arquivos, assim como as outras validações foram feitas (de quantidade de arquivos e nomes repetidos)?"
    // Resposta: No FormControl, tem um atributo "maxSize" com valor limite para 200MB, e quanto o limite atinge, esse atributo bloqueia a inserção do arquivo e nem sequer ativa o método de adição que criei, logo eu não consigo personalizar uma mensagem de erro.
    // Dito isso, eu adicionei um atributo "onDropRejected" que é ativado justamente quando algum arquivo da erro, e daí nele eu personalizo uma função para exibir a mensagem de erro para o tamanho do arquivo.
    // Temos o atributo "onDrop", que é acionado sempre ao soltar os arquivos, e ele está bloqueando a chamada do adicionarArquivos devido ao erro soltado no maxSize do formControl, e temos agora também o "onDropRejected", que será chamado justamente se um erro desse tipo for liberado (erros tratados automaticamente pelo componente, como o tamanho do arquivo);
    // No método adicionarArquivos a gente consegue controlar erros os quais não são conhecidos pelo compomente de drop, no caso são "erros" personalizados por nós, ou seja, regras, tal como o limite de 10 arquivos, e de não pode adicionar um arquivo repetido. Já um erro de tamanho de arquivo isso é controlado nativamente pelo atributo maxSize do componente dropzone;
    // Resumindo: Aquilo que não for um erro de fato, no caso for uma regra NOSSA, como limite de arquivos, tratamentos de nome do arquivo etc, a gente consegue tratar no método de adição, que é acionado pelo atributo "onDrop". Já erros nativos, como o tamanho limite imposto aos arquivos, a gente precisa adicionar o "onDropRejected" que justamente receberá em formato de array cada um dos arquivos que deram erro apenas.

    // Limite: 200MB. Isso foi definido no arquivo "FormControl", aqui eu estou apenas adicionando uma lógica para exibir uma mensagem de retorno pois o Dropzone não mostra erro algum.
    // OBS: Se eu inserir mais de um arquivo por vez e algum deles tiver menos de 200MB, este será adicionado corretamente, mas os outros não. Caso peçam para que não adicione NENHUM, eu preciso passar essa lógica também para o método "adicionar" acima.
    const MAX_FILE_SIZE = 200000000;

    const arquivosGrandes = arquivo.filter((item) => item.file.size > MAX_FILE_SIZE);

    if (arquivosGrandes && arquivosGrandes.length === 1) {
      return alert.error('O tamanho máximo permitido para um arquivo é de 200MB.', { timeout: 5000 });
    }

    if (arquivosGrandes && arquivosGrandes.length > 0) {
      const nomesArquivosGrandes = arquivosGrandes.map((item) => item.file.name).join(', ');
      return alert.error(`Os seguintes arquivos ultrapassam o tamanho máximo permitido de 200MB: ${nomesArquivosGrandes}.`, { timeout: 10000 });
    }

    return alert.error('Ocorreu um erro durante a inserção de arquivo. Confira o tipo dos arquivos a serem inseridos e tente novamente.', { timeout: 5000 });
  };

  const retiraAcentos = (str) => {
    const comAcento = 'ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝŔÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿŕ';
    const semAcento = 'AAAAAAACEEEEIIIIDNOOOOOOUUUUYRsBaaaaaaaceeeeiiiionoooooouuuuybyr';
    let novaStr = '';
    for (let i = 0; i < str.length; i += 1) {
      let troca = false;
      for (let a = 0; a < comAcento.length; a += 1) {
        if (str.substr(i, 1) === comAcento.substr(a, 1)) {
          novaStr += semAcento.substr(a, 1);
          troca = true;
          break;
        }
      }
      if (troca === false) {
        novaStr += str.substr(i, 1);
      }
    }
    return novaStr;
  };

  const checkAndroid = () => {
    const ua = navigator.userAgent.toLowerCase();
    const isAndroid = ua.indexOf('android') > -1;
    if (isAndroid) return true;
    return false;
  };

  const alterarAssunto = (target) => {
    setOrientacoes(null);
    setValues({ ...values, IdSecretariaAssunto: target.value, IdCategoria: '' });

    if (target.value) {
      setSelectDesabilitadoCategoria(false);
      Promise.all([
        fetchOrientacoes(target.value),
        fetchCategoriasPermitidas(target.value),
      ]).then(([dadosOrientacoes, dadosCategorias]) => {
        setOrientacoes(dadosOrientacoes);
        if (!dadosCategorias.Error) {
          setListaCategorias(dadosCategorias);
        }
      });
    } else {
      setSelectDesabilitadoCategoria(true);
      setListaCategorias(null);
    }
  };

  const enviarZeladoria = async (event) => {
    event.preventDefault();

    const dataAgora = new Date().toLocaleString();
    checaCidadeAtiva(dadosCidade && dadosCidade.data && dadosCidade.data.idCidade);

    setCarregando(true);

    if (!validate()) {
      setCarregando(false);
      return;
    }

    const validarConfiguracoesAnonimas = await fetchConfiguracoes();

    if (validarConfiguracoesAnonimas && validarConfiguracoesAnonimas.OcultarAnonimoZeladoria === 'N' && dadosLogin && dadosLogin.data && dadosLogin.data.anonimo === 'anonimo') {
      alert.error('As configurações da cidade foram alteradas e agora não é mais permitido enviar manifestações de forma anônima. Por favor, tente fazer o login.', { timeout: 10000 });
      setCarregando(false);
      return;
    }

    if (coordenadas.lat === Number(dadosCidade.configuracoes.Latitude) && getTotem() !== 'true') {
      setCoordenadas({
        lat: '',
        lng: '',
      });
      const data = async () => {
        const response = await fetchCoordsByAddress(`${values.Endereco} ${values.Numero} ${document.getElementById('selectBairro').options[document.getElementById('selectBairro').selectedIndex].text} ${dadosCidade.configuracoes.Cidade} ${dadosCidade.configuracoes.Estado}`);
        await setCoordenadas({
          lat: await response.lat,
          lng: await response.lng,
        });
        await setValues({
          ...values,
          Latitude: await response.lat,
          Longitude: await response.lng,
        });

        const resposta = await postZeladoria({
          ...values,
          Latitude: await response.lat,
          Longitude: await response.lng,
          anexos: arquivos,
          IdSecretaria: dadosSecretaria.data.idSecretaria,
        });

        if (resposta instanceof Array) {
          alert.error('Atenção, verifique a extensão dos arquivos permitidos.', { timeout: 4000 });
          setCarregando(false);
          return;
        }

        if (resposta.Error) {
          alert.error(resposta.Error, { timeout: 4000 });
          setCarregando(false);
          return;
        }

        if (checkAndroid()) {
          window.location.href = `rawbt:eOuve - ${dadosCidade && dadosCidade.data && dadosCidade.data.nomeCidade}%0A%0A ${resposta.Message.replace('.', '')}%0A Data/hora: ${dataAgora}%0A Secretaria: ${retiraAcentos(dadosSecretaria.data.nomeSecretaria)}%0A Assunto: ${retiraAcentos(assuntoTotem && assuntoTotem.assunto)}%0A Categoria: ${retiraAcentos(categoriaTotem && categoriaTotem.categoria)}`;
        }

        setValues(defaultValues);
        setArquivos([]);

        setCarregando(false);

        alert.info(resposta.Message.replace('.', ''), { timeout: 20000 });

        setValues(defaultValues);

        dispatch(desfazerSecretaria());

        if (dadosLogin && dadosLogin.data && dadosLogin.data.anonimo === 'anonimo') {
          setAuthToken(null);
          dispatch(desfazerConexao());
        }
      };
      await data();
      return;
    }

    const resposta = await postZeladoria({
      ...values,
      anexos: arquivos,
      IdSecretaria: dadosSecretaria.data.idSecretaria,
    });

    if (resposta instanceof Array) {
      alert.error('Atenção, verifique a extensão dos arquivos permitidos.', { timeout: 4000 });
      setCarregando(false);
      return;
    }

    if (resposta.Error) {
      alert.error(resposta.Error, { timeout: 4000 });
      setCarregando(false);
      return;
    }

    if (checkAndroid()) {
      window.location.href = `rawbt:eOuve - ${dadosCidade && dadosCidade.data && dadosCidade.data.nomeCidade}%0A%0A ${resposta.Message.replace('.', '')}%0A Data/hora: ${dataAgora}%0A Secretaria: ${retiraAcentos(dadosSecretaria.data.nomeSecretaria)}%0A Assunto: ${retiraAcentos(assuntoTotem && assuntoTotem.assunto)}%0A Categoria: ${retiraAcentos(categoriaTotem && categoriaTotem.categoria)}`;
    }

    setValues(defaultValues);
    setArquivos([]);

    setCarregando(false);

    // Mensagem de sucesso, exibindo o protocolo, que some depois de 20000ms. Está comentado pois agora é necessário deixar o protocolo sendo exibido.
    // alert.info(resposta.Message, { timeout: 20000 });

    alert.info(resposta.Message);

    setValues(defaultValues);

    dispatch(desfazerSecretaria());

    if (dadosLogin && dadosLogin.data && dadosLogin.data.anonimo === 'anonimo') {
      setAuthToken(null);
      dispatch(desfazerConexao());
    }
  };

  return (
    <>
      <Container>
        <Titulo>Zeladoria</Titulo>

        <Interno>
          <Alerta style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <strong style={{ fontSize: '0.9em' }}>* Os campos com asterisco são obrigatórios.</strong>
          </Alerta>

          <Divisor style={{ marginBottom: 6, paddingBottom: 6 }} />

          <form>
            <FormControl
              type="secretaria"
              dadosSecretaria={dadosSecretaria}
              onClick={() => dispatch(desfazerSecretaria())}
            />

            <LinhaForm>
              <FormControl
                idCampo="selectAssunto"
                value={values.IdSecretariaAssunto}
                label="Assunto:"
                options={listaAssuntos}
                onChange={({ target }) => alterarAssunto(target)}
                // onChange={({ target }) => {
                //   setOrientacoes(null);
                //   setVal('IdSecretariaAssunto', target.value);
                //   setAssunto(target.options[target.selectedIndex].text);
                //   if (target.value) {
                //     fetchOrientacoes(target.value).then((data) => setOrientacoes(data));
                //   }
                // }}
                required
                type="select"
                direita
              />

              {(listaUnidades && listaUnidades.length > 0) && (
                <FormControl
                  idCampo="selectUnidade"
                  value={values.IdUnidade}
                  label="Unidade:"
                  options={listaUnidades}
                  onChange={({ target }) => setVal('IdUnidade', target.value)}
                  type="select"
                  direita
                />
              )}

              <FormControl
                idCampo="selectCategoria"
                value={values.IdCategoria}
                label="Categoria:"
                options={listaCategorias}
                onChange={({ target }) => setVal('IdCategoria', target.value)}
                required
                type="select"
                disabled={selectDesabilitadoCategoria}
              />
            </LinhaForm>

            {(dadosSecretaria.data.nomeSecretaria.toLowerCase() === 'coronavírus' || dadosSecretaria.data.nomeSecretaria.toLowerCase() === 'saúde' || dadosSecretaria.data.nomeSecretaria.toLowerCase() === 'covid-19') && (
            <>
              <LinhaForm>
                <FormControl
                  idCampo="inputCartaoSus"
                  value={sus(values.CartaoSus)}
                  label="Número do cartão SUS:"
                  onChange={({ target }) => setVal('CartaoSus', target.value)}
                  maxLength={19}
                />
              </LinhaForm>
            </>
            )}

            {(orientacoes && orientacoes[0].Campo && orientacoes[0].Campo !== 'NULL') && (
            <>
              <Orientacoes>
                <b>Orientações ao Solicitante:</b>

                <Divisor style={{ marginBottom: 2, paddingBottom: 2 }} />

                <span>{orientacoes[0].Campo}</span>
              </Orientacoes>

              <Divisor size="ultraPequeno" />
            </>
            )}

            <FormControl
              idCampo="areaManifestacao"
              value={values.Descricao}
              label="Manifestação:"
              onChange={({ target }) => setVal('Descricao', target.value)}
              type="textarea"
              maxLength={4000}
              required
            />

            {(dadosCidade && dadosCidade.data && dadosCidade.data.nomeCidade
            && (!dadosCidade.data.nomeCidade.toLowerCase().includes('cincatarina')
            && !dadosCidade.data.nomeCidade.toLowerCase().includes('tce rj'))) && (
              <div>
                {!EstaNaMesmaCidade && (
                  <>
                    <OrientacoesLocalizacao>
                      <b>Atenção, Solicitante:</b>

                      <Divisor style={{ marginBottom: 2, paddingBottom: 2 }} />

                      <span>{logErroLocalizacao}</span>
                    </OrientacoesLocalizacao>

                    <Divisor size="ultraPequeno" />
                  </>
                )}

                <Mapa
                  coordenadas={coordenadas}
                  onClick={({ latLng }) => {
                    setCoordenadas({
                      lat: latLng.lat(),
                      lng: latLng.lng(),
                    });
                    fetchGeocodeByCoords(latLng.lat(), latLng.lng()).then((data) => {
                      setValues({
                        ...values,
                        Cep: (data && data.cep) ? data.cep : '',
                        Endereco: (data && data.endereco) ? data.endereco : '',
                        Numero: (data && data.numero) ? data.numero : '',
                        IdBairro: (data && data.bairro) ? getIdBairro(data.bairro) : '',
                        Latitude: latLng.lat(),
                        Longitude: latLng.lng(),
                      });
                    });
                  }}
                />
              </div>
            )}

            <LinhaForm>
              <FormControl
                idCampo="inputEndereco"
                value={values.Endereco}
                label="Endereço da manifestação:"
                onChange={({ target }) => setVal('Endereco', target.value)}
                required
                direita
                tamanhoFlex={7}
              />

              <FormControl
                idCampo="inputNumero"
                value={number(values.Numero)}
                label="Número:"
                onChange={({ target }) => setVal('Numero', target.value)}
                maxLength={5}
              />
            </LinhaForm>

            <LinhaForm>
              <FormControl
                idCampo="inputCep"
                value={cep(values.Cep)}
                label="CEP:"
                onChange={({ target }) => setVal('Cep', target.value)}
                direita
                maxLength={9}
              />

              <FormControl
                idCampo="inputReferencia"
                value={values.Referencia}
                label="Referência:"
                onChange={({ target }) => setVal('Referencia', target.value)}
                direita
                tamanhoFlex={2}
              />

              <FormControl
                idCampo="selectBairro"
                value={values.IdBairro}
                type="select"
                label="Bairro:"
                options={listaBairros}
                onChange={({ target }) => setVal('IdBairro', target.value)}
                required
              />
            </LinhaForm>

            {(dadosCidade && dadosCidade.data && dadosCidade.data.nomeCidade && !dadosCidade.data.nomeCidade.toLowerCase().includes('cincatarina')) && (
              <ColunaForm borda style={{ marginBottom: 12 }}>
                <LinhaFormGap style={{ justifyContent: 'space-between' }}>
                  <Pergunta>
                    Solicitante deseja prioridade na tramitação? Conforme
                    {' '}
                    <a href="https://www.planalto.gov.br/ccivil_03/LEIS/L9784.htm#art69a" target="_blank" rel="noreferrer" title="Lei Federal nº 9.784/1999">Lei Federal nº 9.784/1999</a>
                    {dadosCidade && dadosCidade.data && dadosCidade.data.nomeCidade === 'Juiz de Fora' && (
                      <>
                        {' '}
                        e
                        {' '}
                        <a href="https://jflegis.pjf.mg.gov.br/norma.php?chave=0000051079" target="_blank" rel="noreferrer" title="Lei Municipal nº 14.511/2022">Lei Municipal nº 14.511/2022</a>
                      </>
                    )}
                  </Pergunta>
                  <Linha style={{ gap: 30, justifyContent: 'flex-end' }}>
                    <label htmlFor="radioSimUrgente">
                      <input type="radio" id="radioSimUrgente" value="S" name="Urgente" onChange={({ target }) => setVal('Urgente', target.value)} />
                      {' '}
                      Sim
                    </label>
                    {' '}
                    <label htmlFor="radioNaoUrgente">
                      <input type="radio" id="radioNaoUrgente" value="N" name="Urgente" onChange={({ target }) => setValues({ ...values, Urgente: target.value, IdOpcaoUrgencia: '' })} defaultChecked />
                      {' '}
                      Não
                    </label>
                  </Linha>
                </LinhaFormGap>

                {values.Urgente === 'S' && (
                  <>
                    <p>
                      <b>ATENÇÃO:</b>
                      {' '}
                      A pessoa interessada na obtenção do benefício, independente da opção selecionada, deverá, obrigatoriamente, anexar prova de sua condição para ser validada. Caso não apresente documento comprobatório a manifestação seguirá tramitação normal.
                    </p>

                    <FormControl
                      idCampo="selectUrgenteJustificativa"
                      value={values.IdOpcaoUrgencia}
                      label="Escolha uma das opções:"
                      options={listaUrgenteJustificativas}
                      onChange={({ target }) => setVal('IdOpcaoUrgencia', target.value)}
                      required
                      type="select"
                    />
                  </>
                )}
              </ColunaForm>
            )}

            <FormControl
              type="arquivo"
              dadosArquivos={arquivos}
              onDrop={adicionarArquivo}
              onDropRejected={ExibirErroTamanhoArquivo}
              onRemove={removerArquivo}
              required={values.Urgente === 'S'}
            />

            <FormFooter>
              {carregando !== true
                ? (
                  <>
                    <Botao
                      label="Enviar"
                      type="submit"
                      onClick={enviarZeladoria}
                    />
                  </>
                )
                : (
                  <Carregar />
                )}
            </FormFooter>

          </form>

        </Interno>
      </Container>
    </>
  );
};

export default FormularioZeladoria;
